<template>
<div class="contain">
    <div class="signs">
      <img style="width:100%;" src="@/assets/images/newsLists/banner.png" alt />
      <img class="signs_title" src="@/assets/images/newsLists/banner_text.png" alt="">
    </div>
        <ul class="lists">
            <li class="item" v-for="(item,index) in lists" :key="index" @click="goParam(index)">
                <div class="box">
                    <img :src="item.titlepic" alt>
                    <div class="msg">
                        <p class="msg-title">{{item.title}}</p>
                        <p class="text">{{item.brief}}</p>
                        <p class="date">{{new Date(parseInt(item.addtime)).getFullYear()}}-{{new Date(parseInt(item.addtime)).getMonth() + 1}}-{{new Date(parseInt(item.addtime)).getDay() + 1}}</p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total, prev, pager, next, jumper" v-bind:total="newsTotalCount"></el-pagination>
        </div>
    </div>
</template>

<script>
import api from "@/axios.js";
export default {
    data() {
        return {
            lists: [
               /* {
                            titlepic: require("../assets/images/newsLists/img.png"),
                            title: "新闻标题容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容",
                            brief: "内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容",
                            addtime: "1559541604622"
                        } */
            ],
            // 新闻总数
            newsTotalCount: 0,
            // 分页size
            pageSize: 10,
            pageNum: 1
        };
    },
    methods: {
        // 分页size改变
        handleSizeChange(val) {},
        // 分页页数改变
        handleCurrentChange(val) {
            this.getNewsList(val);
        },
        goParam(index) {
            index += (this.pageNum - 1) * this.pageSize;
            this.$router.push({
                name: "NewsDetial",
                params: {
                    id: index
                }
            });
        },
        // 获取新闻列表
        getNewsList(pageNum) {
            this.toTop();
            this.pageNum = pageNum;
            api.getNewsList({
                    pageNum: pageNum,
                    pageSize: this.pageSize
                }).then(({
                    data
                }) => {
                    this.lists = data.list;
                    this.newsTotalCount = data.total;
                }).catch(err => {
                    this.$message.error(`获取数据失败`);
                });
        },
        toTop() {
            var tBody = document.querySelector("html");
            tBody.scrollTop = document.querySelector(".lists").offsetTop;
        }
    },
    mounted() {
        this.getNewsList(1);
    }
};
</script>

<style scoped>
.contain {
    width: 100%;
    margin: 0 auto;
    font-size: 14px;
    color: #505050;
    /* background-color: #f7f7f7; */
}

.signs {
  width: 100%;
  margin-bottom: 60px;
  position: relative;
}

.signs .signs_title {
    position: absolute;
    top:53%;
    left:32%;
    transform: translate(-50% ,-50%);
}

.lists {
    width: 1200px;
    margin: 100px auto 50px;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}

.item {
    cursor: pointer;
    width: 587px;
    height: 184px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.05); 
    margin-bottom: 26px;
}

/* .item:hover {
    box-shadow: #f5f5f5 0 0 5px 5px;
} */

.box {
    height: 100%;
    position: relative;
}

.box>img {
    width: 200px;
    height: 150px;
    float: left;
    margin: 12px 18px 12px 12px;
    border-radius: 4px;
}

.msg {
    width: 344px;
    height: 100%;
    display: inline-block;
    vertical-align: middle;
}

.msg-title {
    color: #333333;
    font-size: 18px;
    text-align: left;
    margin-top: 24px;
    font-weight: 700;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.text,
.date {
    text-align: left;
    margin-top: 25px;
}

.text {
    font-size: 16px;
    color:#333;
    width: 100%;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.date {
    margin-top: 20px;
    font-size: 14px;
    color: #909399;
}

.pagination {
    text-align: center;
    margin: 60px 0  160px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/newsLists.vue